import React from "react";

export default function ServiceTypeSelector({ serviceType, setServiceType }) {
  const Card = ({ active, icon, title, subtitle, onClick }) => (
    <button
      type="button"
      onClick={onClick}
      className={`flex flex-col items-center justify-center p-6 rounded-xl border-2 transition-all group ${
        active
          ? "border-primary bg-primary/5"
          : "border-slate-200 dark:border-slate-800 hover:border-primary/50"
      }`}
    >
      <span
        className={`material-icons text-3xl mb-2 transition-colors ${
          active ? "text-primary" : "text-slate-400 group-hover:text-primary"
        }`}
      >
        {icon}
      </span>
      <span
        className={`font-bold text-lg ${
          active ? "text-slate-900 dark:text-white" : "text-slate-700 dark:text-slate-300"
        }`}
      >
        {title}
      </span>
      <span className="text-sm text-slate-500 mt-1">{subtitle}</span>
    </button>
  );

  return (
    <section>
      <h2 className="text-2xl font-bold mb-6 flex items-center gap-2 text-slate-900 dark:text-white">
        <span className="w-8 h-8 rounded-full bg-primary/10 text-primary flex items-center justify-center text-sm">
          1
        </span>
        How would you like your order?
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <Card
          active={serviceType === "eat_in"}
          icon="restaurant"
          title="Eat In"
          subtitle="I'm in the restaurant"
          onClick={() => setServiceType("eat_in")}
        />
        <Card
          active={serviceType === "pick_up"}
          icon="shopping_bag"
          title="Pick Up"
          subtitle="I'll come to collect my order"
          onClick={() => setServiceType("pick_up")}
        />
        {/* <Card
          active={serviceType === "delivery"}
          icon="local_shipping"
          title="Delivery"
          subtitle="Bring it to my address"
          onClick={() => setServiceType("delivery")}
        /> */}
      </div>
    </section>
  );
}
